// 한 부모 정산의 여러 입금 로그는 각각 실제 입금액만 합산한다.
// 부모 금액은 기간 전체에서 정산 PK당 한 번만 포함하며 PK가 없으면 추정하지 않는다.
export function createUnmeDepositLogTracker() {
  const seen = new Set();
  return (row) => {
    const id = row?.settlement_id ?? row?.settlementId;
    if (id == null || String(id).trim() === '') return { includeParent: false, parentAmountReason: '정산 ID 확인 필요' };
    const key = String(id);
    if (seen.has(key)) return { includeParent: false, parentAmountReason: '같은 정산의 중복 금액 제외' };
    seen.add(key);
    return { includeParent: true, parentAmountReason: '' };
  };
}

// 유앤미 완료 내역의 id는 입금 로그 PK이고 지급 배치는 부모 정산 PK로 연결한다.
export function depositSettlementKey(item, unmeEnabled) {
  const id = unmeEnabled ? item?.settlementId : item?.id;
  return id == null || id === '' ? '' : String(id);
}
